import { gql } from '@apollo/client'

import { usePaginatedQuery } from 'hooks'

const CONFIG_LIST_QUERY = gql`
  query ConfigList($offset: Int, $max: Int) {
    configList(offset: $offset, max: $max) {
      totalCount
      results {
        id
        name
        value
        description
      }
    }
  }
`

export const useConfigListQuery = opts => usePaginatedQuery(CONFIG_LIST_QUERY, opts)
